import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { PartTypeAddDialogComponent } from './components/part-type-add-dialog/part-type-add-dialog.component';
import { PartTypeListComponent } from './components/part-type-list/part-type-list.component';
import { PartTypeRoutingModule } from './part-type-routing.module';
import { PartTypeService } from './service/part-type.service';

@NgModule({
  imports: [SharedModule, CommonModule, PartTypeRoutingModule],
  providers: [PartTypeService],
  declarations: [PartTypeListComponent, PartTypeAddDialogComponent],
  entryComponents: [PartTypeAddDialogComponent]
})
export class PartTypeModule {}
